<form class="w-full" [formGroup]="searchForm">
    <div class="relative rounded p-4 md:p-6 mb-4 flex flex-col gap-4 bg-white text-black shadow-md z-10">
        <div class="w-full">
            <label for="keywordsInput" class="block text-sm font-medium leading-6 text-gray-900" i18n>Keywords</label>
            <div class="relative mt-2">
                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                    <svg
                        class="h-5 w-5 text-gray-400"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                        aria-label="Search icon">
                        <path
                            fill-rule="evenodd"
                            d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z"
                            clip-rule="evenodd" />
                    </svg>
                </div>
                <input
                    placeholder="e.g. Bartender, London"
                    id="keywordsInput"
                    formControlName="keywords"
                    class="block w-full h-10 rounded-md border-0 p-2 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 text-gray-900" />
            </div>
        </div>

        <div class="md:flex block">
            <div class="w-full grow mb-4">
                <label for="regionInput" class="block text-sm font-medium leading-6 text-gray-900" i18n>Location</label>
                <div class="relative mt-2">
                    <button
                        type="button"
                        class="w-full flex items-center gap-x-1 text-sm leading-6 text-gray-900"
                        (click)="showCategory = false; showRegions = !showRegions"
                        aria-expanded="false">
                        {{
                            searchForm.get("locationLabel").value
                                ? searchForm.get("locationLabel").value
                                : "Select a region"
                        }}
                        <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path
                                fill-rule="evenodd"
                                d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                                clip-rule="evenodd" />
                        </svg>
                    </button>
                </div>
            </div>
            <div class="w-full grow mb-4">
                <label for="regionInput" class="block text-sm font-medium leading-6 text-gray-900" i18n
                    >Department</label
                >
                <div class="relative mt-2">
                    <button
                        type="button"
                        class="w-full flex items-center gap-x-1 text-sm leading-6 text-gray-900"
                        (click)="showRegions = false; showCategory = !showCategory"
                        aria-expanded="false">
                        {{
                            searchForm.get("categoryId").value ? selectedCategory : "Select a department"
                        }}
                        <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path
                                fill-rule="evenodd"
                                d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                                clip-rule="evenodd" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>

        <div
            *ngIf="showRegions"
            class="w-full mx-auto hidden md:grid max-w-7xl grid-cols-1 gap-x-4 gap-y-4 px-4 py-4 xl:grid-cols-3 2xl:grid-cols-5">
            <ng-container [ngTemplateOutlet]="regionsTemplate"></ng-container>
        </div>

        <div
            *ngIf="showCategory"
            class="w-full mx-auto hidden md:grid max-w-7xl grid-cols-1 gap-x-4 gap-y-4 px-4 py-4 xl:grid-cols-3 2xl:grid-cols-5">
            <ng-container [ngTemplateOutlet]="categoriesTemplate"></ng-container>
        </div>

        <div class="w-full flex gap-2 justify-end">
            <button
                role="button"
                aria-label="Clear search"
                name="clear"
                class="rounded-full px-3.5 py-2.5 text-sm font-semibold bg-white hover:bg-gray-200 text-gray-900"
                (click)="clearSearch()"
                i18n>
                Clear Search
            </button>
            <button
                role="button"
                aria-label="Search"
                name="search"
                class="inline-flex items-center gap-1 rounded-full bg-gray-200 text-gray-900 hover:bg-black hover:text-white px-3.5 py-2.5 text-sm font-semibold"
                (click)="emitSearch()"
                i18n>
                <svg
                    class="-ml-0.5 h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                    aria-label="Search icon">
                    <path
                        fill-rule="evenodd"
                        d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z"
                        clip-rule="evenodd" />
                </svg>
                Search
            </button>
        </div>
    </div>
</form>

<app-dialog-container class="block md:hidden" *ngIf="showRegions" (onClose)="showRegions = false">
    <div class="w-screen px-4">
        <h3 class="font-bold text-lg">Select a location</h3>
        <ng-container [ngTemplateOutlet]="regionsTemplate"></ng-container>
    </div>
</app-dialog-container>
<app-dialog-container class="block md:hidden" *ngIf="showCategory" (onClose)="showCategory = false">
    <div class="w-screen px-4">
        <h3 class="font-bold text-lg">Select a department</h3>
        <ng-container [ngTemplateOutlet]="categoriesTemplate"></ng-container>
    </div>
</app-dialog-container>

<ng-template #regionsTemplate>
    <div *ngFor="let region of regions | keyvalue : returnZero">
        <h3 class="text-sm font-medium leading-6 text-gray-500 mt-4 cursor-pointer" (click)="setLocation(region.key)">{{ region.key }}</h3>
        <div class="md:mt-6 mt-2 flow-root">
            <div class="-my-2">
                <button
                    *ngFor="let location of region.value"
                    type="button"
                    (click)="setLocation(location)"
                    class="flex gap-x-4 pl-2 md:pl-0 py-2 text-sm font-semibold leading-6 text-gray-900">
                    {{ location }}
                </button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #categoriesTemplate>
    <div *ngFor="let department of departments">
        <h3 class="text-sm font-medium leading-6 text-gray-500 mt-4 cursor-pointer" (click)="setCategory(department)">{{ department.name }}</h3>
        <div class="md:mt-6 mt-2 flow-root">
            <div class="-my-2">
                <button
                    *ngFor="let category of department.children"
                    type="button"
                    (click)="setCategory(category)"
                    class="flex gap-x-4 pl-2 md:pl-0 py-2 text-sm font-semibold leading-6 text-gray-900">
                    {{ category.name }}
                </button>
            </div>
        </div>
    </div>
</ng-template>
